/**
 * What a sign-in screen says about how long the code and the link last.
 *
 * Four doors each wrote their own sentence, and every one of them said the code
 * expired in ten minutes. That was true until the code's life became thirty minutes
 * and the emailed link's stayed at ten — two clocks, deliberately, because the link
 * signs somebody in on its own and the typed code does not. Five hand-written
 * sentences then said the same wrong thing in five places.
 *
 * The server has always sent the real expiry on every challenge. This reads it, so
 * the screens stop carrying a number that has to be remembered and updated by hand.
 */

/** The link's life is fixed by policy rather than returned per challenge. */
const LINK_MINUTES = 10;

/**
 * A whole sentence, ready to render.
 *
 * Falls back to no clock time rather than an invented one: a screen that cannot read
 * the expiry should say less, not guess. Never states a number for the code.
 */
export function signInExpiryNote(expiresAt: string | null | undefined): string {
  const at = clockTime(expiresAt);
  return at
    ? `It expires at ${at}. The link in the email lasts ${LINK_MINUTES} minutes.`
    : `The link in the email lasts ${LINK_MINUTES} minutes, and the code lasts longer.`;
}

function clockTime(expiresAt: string | null | undefined): string | null {
  if (!expiresAt) return null;
  const parsed = Date.parse(expiresAt);
  if (Number.isNaN(parsed)) return null;
  return new Date(parsed).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}
